import styled from '@emotion/styled';
import {colors, mq} from 'ui/config';
import {MainTitleDark, TextSmall} from 'ui';

export const Container = styled('div')({
  backgroundColor: colors.white,
  display: 'flex',
});

export const BorderContainer = styled('div')({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  border: '1px solid',
  borderColor: colors.caramel,
  margin: 4,
  padding: 20,
  width: '100%',
});

export const Title = styled(MainTitleDark)({
  fontSize: 26,
  lineHeight: '28px',
  padding: 0,
  marginBottom: 6,
  [mq('small')]: {
    fontSize: 26,
  },
});

export const Small = styled(TextSmall)({
  color: colors.darkBrown,
  textAlign: 'center',
  marginBottom: 8,
});
